import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bpCustomManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  bpCustomManageForecastTreeData: [],
  bpCustomManageForecastFinalTreeData: [],
};

const BPCustomManageScreenRedux = createSlice({
  name: "BPCustomManageScreenRedux",
  initialState,
  reducers: {
    setBPCustomManageForecastBottlerData: (state, action) => {
      state.bpCustomManageForecastBottlerData = action.payload;
    },
    setBPCustomManageForecastTreeData: (state, action) => {
      state.bpCustomManageForecastTreeData = action.payload;
    },
    setBPCustomManageForecastFinalTreeData: (state, action) => {
      state.bpCustomManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setBPCustomManageForecastBottlerData,
  setBPCustomManageForecastTreeData,
  setBPCustomManageForecastFinalTreeData,
} = BPCustomManageScreenRedux.actions;
export default BPCustomManageScreenRedux.reducer;
